import './styles.css';
import { BlackwakeGame } from './game/BlackwakeGame';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');
const hudRoot = document.querySelector<HTMLElement>('#hud-root');
const modalRoot = document.querySelector<HTMLElement>('#modal-root');
const toastRoot = document.querySelector<HTMLElement>('#toast-root');

if (!canvas || !hudRoot || !modalRoot || !toastRoot) {
  throw new Error('Blackwake Isles could not find its required page elements.');
}

const game = new BlackwakeGame(canvas, hudRoot, modalRoot, toastRoot);
void game.start();
